import {
  Button,
  Classes,
  Dialog,
  FileInput,
  FormGroup,
  H5,
  InputGroup,
  Popover,
  Switch,
  Tab,
  Tabs,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IMva } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { MvaStorePA } from "../../stores/mvas/MvaStorePA";
import { Pager } from "../utils/Pager";
import { MvaPaDialogCreate } from "./MvaPaDialogCreate";
import * as moment from "moment";
import {
  MDBBtn,
  MDBCol,
  MDBRow,
} from "mdbreact";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { MvaPaDialogEdit } from "./MvaPaDialogEdit";
import { MvaPaDialogDuplicar } from "./MvaPaDialogDuplicar";

var debounce = require('lodash.debounce');

interface State {
  filter: string
}

@observer
export class MvasPaPage extends React.Component<{}, State> {

  obs = observable({
    adding: false as boolean,
    edit_mva: null as IMva,
    duplicar_mva: null as IMva,
    loading_export: false as boolean,
    fetchOptions: {} as any,
    loading_import: false as boolean,
    open_import_produtos: false as boolean,
    file_name: "Selecione um arquivo em xlsx igual ao exportado!" as string,
  })

  constructor(props) {
    super(props)

    this.state = {
      filter: ""
    }

    this.obs.fetchOptions = debounce(this.handlePageFilter.bind(this), 800);

  }
  componentDidMount() {
    AppStore.setTitle("MVAs Pará");
    MvaStorePA.handlePageFilter(1, "")
  }

  handleAdd = () => {
    this.obs.adding = true;
  };

  handleAddClose = async () => {
    this.obs.adding = null;

    await MvaStorePA.handlePageFilter(MvaStorePA.obs.currentPage, this.state.filter);

  };

  handleEditClose = async () => {
    this.obs.edit_mva = null;

    await MvaStorePA.handlePageFilter(MvaStorePA.obs.currentPage, this.state.filter);

  };

  handleDuplicaClose = async () => {
    this.obs.duplicar_mva = null;

    await MvaStorePA.handlePageFilter(MvaStorePA.obs.currentPage, this.state.filter);

  };

  handlePageChange = (page: number) => {
    MvaStorePA.handlePageFilter(MvaStorePA.obs.currentPage, this.state.filter);
  };

  ncmFormatter(ncm) {
    const ncmHTML = ncm.split("\n")?.map((ncm, index) => {
      return <p>{ncm}</p>;
    });
    return (
      <div>
        {ncmHTML}
      </div>
    );
  }

  validadeFormatter(d) {
    return d ? moment(d).add(3, "hour").format("DD/MM/YYYY") : null;
  }

  handleChangeVigencia() {
    MvaStorePA.obs.filter_vigencia = !MvaStorePA.obs.filter_vigencia;
    MvaStorePA.handlePageFilter(MvaStorePA.obs.currentPage, this.state.filter);
  }

  async handlePageFilter() {
    MvaStorePA.obs.currentPage = 1
    await MvaStorePA.handlePageFilter(1, this.state.filter)
  }

  async handleExport() {
    this.obs.loading_export = true

    await MvaStorePA.handleExport("pa",MvaStorePA.obs.selectedTab == "entrada")

    this.obs.loading_export = false
  }

  async handleChangeTab(tabId: string) {
    MvaStorePA.obs.selectedTab = tabId

    MvaStorePA.obs.filter_vigencia = true
    this.setState({ filter: "" })

    await MvaStorePA.handlePageFilter(1, "")
  }

  handleChangeFilter(e) {

    this.setState({ filter: e }, () => {

      this.obs.fetchOptions()

    })

  }

  async handleDeleteMva(id) {
    let res = await MvaStorePA.handleDeleteMva(id)

    if (res) {
      await MvaStorePA.handlePageFilter(MvaStorePA.obs.currentPage, this.state.filter);
    }

  }

  createCustomSearchField = (props) => {
    return (
      <MDBRow>
        <MDBCol xl="10" lg="10" md="10" sm="10">
          <InputGroup
            round
            style={{ borderRadius: "10px" }}
            placeholder="Filtrar (Item, CEST, Descrição)"
            value={this.state.filter}
            onChange={(e) => this.handleChangeFilter(e.target.value)}
          />
        </MDBCol>

        <MDBCol md="2">
          <MDBBtn
            className="btnDefault btnBuscarNfe"
            style={{ marginTop: 4 }}
            onClick={() => this.handlePageFilter()}
          >
            Buscar
          </MDBBtn>
        </MDBCol>
      </MDBRow>
    );
  };

  handleImport() {

    this.obs.open_import_produtos = true;

  };

  handleFileInputChange = async (event) => {

    this.obs.loading_import = true;

    const file = event.target.files[0];

    this.obs.file_name = file.name

    var data = new FormData();

    data.append("file", file);
    data.append("entrada", MvaStorePA.obs.selectedTab == "entrada" ? "true" : "false");
    data.append("estado", "pa");

    this.obs.open_import_produtos = false;

    let res = await MvaStorePA.handleImport(data)

    if (res) {

      MvaStorePA.obs.currentPage = 1;

      await MvaStorePA.handlePageFilter(1, "")

      this.obs.file_name = "Selecione um arquivo xlsx igual ao exportado!"

    }

    this.obs.loading_import = false;

  };

  render() {
    let items = MvaStorePA.obs.mvas?.map((mva) => {
      return (
        {
          id: mva.id,
          margem_distribuidor_12: mva.margem_distribuidor_12 ? mva.margem_distribuidor_12 + "%" : "",
          margem_distribuidor_19: mva.margem_distribuidor_19 ? mva.margem_distribuidor_19 + "%" : "",
          margem_distribuidor_4: mva.margem_distribuidor_4 ? mva.margem_distribuidor_4 + "%" : "",
          margem_distribuidor_7: mva.margem_distribuidor_7 ? mva.margem_distribuidor_7 + "%" : "",
          margem_industrial_12: mva.margem_industrial_12 ? mva.margem_industrial_12 + "%" : "",
          margem_industrial_19: mva.margem_industrial_19 ? mva.margem_industrial_19 + "%" : "",
          margem_industrial_4: mva.margem_industrial_4 ? mva.margem_industrial_4 + "%" : "",
          margem_industrial_7: mva.margem_industrial_7 ? mva.margem_industrial_7 + "%" : "",
          produto_cest: mva.produto_cest,
          produto_desc: mva.produto_desc,
          produto_ncm: mva.produto_ncm,
          item: mva.item,
          valido_de: mva.valido_de,
          valido_ate: mva.valido_ate,
          entrada: mva.entrada,
        }
      );
    });

    const handleEditMva = (mva) => {
      this.obs.edit_mva = mva;

      if (this.obs.edit_mva.valido_de != null) {
        let newDate = new Date(this.obs.edit_mva.valido_de)
        newDate.setHours(newDate.getHours() + 24)
        this.obs.edit_mva.valido_de = newDate
      }

      if (this.obs.edit_mva.valido_ate != null) {
        let newDateAte = new Date(this.obs.edit_mva.valido_ate)
        newDateAte.setHours(newDateAte.getHours() - 3)
        this.obs.edit_mva.valido_ate = newDateAte
      }
    };

    const handleDuplicarMva = (mva) => {
      this.obs.duplicar_mva = mva;

      if (this.obs.duplicar_mva.valido_de != null) {
        let newDate = new Date(this.obs.duplicar_mva.valido_de)
        newDate.setHours(newDate.getHours() + 24)
        this.obs.duplicar_mva.valido_de = newDate
      }

      if (this.obs.duplicar_mva.valido_ate != null) {
        let newDateAte = new Date(this.obs.duplicar_mva.valido_ate)
        newDateAte.setHours(newDateAte.getHours() - 3)
        this.obs.duplicar_mva.valido_ate = newDateAte
      }
    }

    const buttonFormatterDetalhes = (cell, row) => {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={(e) => handleEditMva(row)}
          >
            <img src="/images/edit.png" width={25} />
          </MDBBtn>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={(e) => handleDuplicarMva(row)}
          >
            <img src="/images/duplicate.svg" width={25} />
          </MDBBtn>
          <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
            <MDBBtn color="default" rounded size="sm">
              <img src="/images/bin.png" width={25} />
            </MDBBtn>
            <div>
              <H5>Confirmar exclusão?</H5>
              <p>Confirmar exclusão do MVA?</p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 15,
                }}
              >
                <Button
                  className={Classes.POPOVER_DISMISS}
                  style={{ marginRight: 10 }}
                >
                  Cancelar
                </Button>
                <Button
                  intent="danger"
                  className={Classes.POPOVER_DISMISS}
                  onClick={() => this.handleDeleteMva(row.id)}
                >
                  Excluir
                </Button>
              </div>
            </div>
          </Popover>
        </>
      );
    }

    const options = {
      searchField: this.createCustomSearchField,
    };

    let user_admin = AppStore.obs1.usuario ? AppStore.obs1.usuario.admin : false

    return (
      <div>

        <MDBRow>
          <MDBCol md="12">
            {user_admin &&
              <MDBBtn className="btnDefault noFloat" onClick={this.handleAdd} style={{ marginRight: 15 }}>
                Adicionar MVA
              </MDBBtn>
            }

            <Button
              icon="export"
              className="btnRoxo"
              onClick={() => this.handleExport()}
              loading={this.obs.loading_export}
              style={{ marginRight: 15 }}
            >
              Exportar
            </Button>

            {user_admin &&
              <Button
                icon="import"
                className="btnRoxo"
                onClick={() => this.handleImport()}
                loading={this.obs.loading_import}
              >
                Importar
              </Button>
            }

          </MDBCol>
        </MDBRow>

        <Tabs
          id="tabs"
          className={"tabsCalculos"}
          selectedTabId={MvaStorePA.obs.selectedTab}
          onChange={(tabId) => this.handleChangeTab(String(tabId))}
        >

          <Tab
            id="entrada"
            title="Entrada"
            panel={<>
              <MDBRow>
                <div style={{ display: "flex", width: "100%" }}>
                  <Switch
                    label={"Filtro Vigência"}
                    checked={MvaStorePA.obs.filter_vigencia}
                    onChange={(e: any) => this.handleChangeVigencia()}
                    innerLabelChecked="Vigentes" innerLabel="Não vigentes"
                    style={{ marginTop: 12, marginLeft: "15px", fontSize: 12, fontWeight: 600 }}
                    alignIndicator="right"
                  />
                </div>
              </MDBRow>

              <BootstrapTable
                className="TableDefault"
                ref="table"
                data={items}
                options={options}
                search
              >
                <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                <TableHeaderColumn dataField="item" width="5%">Item</TableHeaderColumn>
                <TableHeaderColumn dataField="produto_cest" width="10%">CEST</TableHeaderColumn>
                <TableHeaderColumn dataField="produto_ncm" dataFormat={this.ncmFormatter} width="10%">NCM/SH</TableHeaderColumn>
                <TableHeaderColumn dataField="produto_desc" width="20%">Descrição</TableHeaderColumn>
                <TableHeaderColumn dataField="valido_de" dataFormat={this.validadeFormatter} width="15%">Valido de</TableHeaderColumn>
                <TableHeaderColumn dataField="valido_ate" dataFormat={this.validadeFormatter} width="15%">Valido até</TableHeaderColumn>
                <TableHeaderColumn dataField="margem_industrial_4" width="15%">Industrial 4%</TableHeaderColumn>
                <TableHeaderColumn dataField="margem_industrial_7" width="15%">Industrial 7%</TableHeaderColumn>
                <TableHeaderColumn dataField="margem_industrial_12" width="15%">Industrial 12%</TableHeaderColumn>
                <TableHeaderColumn dataField="margem_distribuidor_4" width="15%">Distribuidor 4%</TableHeaderColumn>
                <TableHeaderColumn dataField="margem_distribuidor_7" width="15%">Distribuidor 7%</TableHeaderColumn>
                <TableHeaderColumn dataField="margem_distribuidor_12" width="15%">Distribuidor 12%</TableHeaderColumn>
                {user_admin && <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="15%">Ações</TableHeaderColumn>}
              </BootstrapTable>

              <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
                <Pager
                  currentPage={MvaStorePA.obs.currentPage}
                  totalCount={MvaStorePA.obs.length_mvas}
                  pageSize={20}
                  onPageChange={page => this.handlePageChange(MvaStorePA.obs.currentPage = page)}
                />
              </div>

            </>} />

          <Tab
            id="saida"
            title="Saída"
            panel={<>
              <MDBRow>
                <div style={{ display: "flex", width: "100%" }}>
                  <Switch
                    label={"Filtro Vigência"}
                    checked={MvaStorePA.obs.filter_vigencia}
                    onChange={(e: any) => this.handleChangeVigencia()}
                    innerLabelChecked="Vigentes" innerLabel="Não vigentes"
                    style={{ marginTop: 12, marginLeft: "15px", fontSize: 12, fontWeight: 600 }}
                    alignIndicator="right"
                  />
                </div>
              </MDBRow>

              <BootstrapTable
                className="TableDefault"
                ref="table"
                data={items}
                options={options}
                search
              >
                <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                <TableHeaderColumn dataField="item" width="5%">Item</TableHeaderColumn>
                <TableHeaderColumn dataField="produto_cest" width="10%">CEST</TableHeaderColumn>
                <TableHeaderColumn dataField="produto_ncm" dataFormat={this.ncmFormatter} width="10%">NCM/SH</TableHeaderColumn>
                <TableHeaderColumn dataField="produto_desc" width="20%">Descrição</TableHeaderColumn>
                <TableHeaderColumn dataField="valido_de" dataFormat={this.validadeFormatter} width="15%">Valido de</TableHeaderColumn>
                <TableHeaderColumn dataField="valido_ate" dataFormat={this.validadeFormatter} width="15%">Valido até</TableHeaderColumn>
                {/* <TableHeaderColumn dataField="margem_industrial_4" width="15%">Industrial 4%</TableHeaderColumn> */}
                {/* <TableHeaderColumn dataField="margem_industrial_7" width="15%">Industrial 7%</TableHeaderColumn> */}
                <TableHeaderColumn dataField="margem_industrial_19" width="15%">Industrial 19%</TableHeaderColumn>
                {/* <TableHeaderColumn dataField="margem_distribuidor_4" width="15%">Distribuidor 4%</TableHeaderColumn> */}
                {/* <TableHeaderColumn dataField="margem_distribuidor_7" width="15%">Distribuidor 7%</TableHeaderColumn> */}
                <TableHeaderColumn dataField="margem_distribuidor_19" width="15%">Distribuidor 19%</TableHeaderColumn>
                {user_admin && <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="15%">Ações</TableHeaderColumn>}
              </BootstrapTable>

              <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
                <Pager
                  currentPage={MvaStorePA.obs.currentPage}
                  totalCount={MvaStorePA.obs.length_mvas}
                  pageSize={20}
                  onPageChange={page => this.handlePageChange(MvaStorePA.obs.currentPage = page)}
                />
              </div>

            </>} />

        </Tabs>

        <Dialog
          isOpen={this.obs.open_import_produtos}
          title={"Importar MVAs - " + MvaStorePA.obs.selectedTab.toUpperCase()}
        >
          <div className={Classes.DIALOG_BODY}>

            <p style={{ color: "rgba(255, 0, 0, 0.82)" }}>

              <b>Observação:</b> Ao importar o arquivo, todos os mvas cadastrados no sistema serão substituídos pelos mvas presentes no arquivo, conforme o tipo selecionado na aba. <br />

            </p>

            <br />

            <FormGroup label="">
              <FileInput text={this.obs.file_name} className="bp3-fill bp3-file-input-has-selection input-file-certificado" onInputChange={this.handleFileInputChange} />
            </FormGroup>
          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.obs.open_import_produtos = false} />
            </div>
          </div>

        </Dialog>

        {this.obs.adding && <MvaPaDialogCreate onClose={this.handleAddClose} />}
        {this.obs.edit_mva && <MvaPaDialogEdit mva={this.obs.edit_mva} onClose={this.handleEditClose} />}
        {this.obs.duplicar_mva && <MvaPaDialogDuplicar mva={this.obs.duplicar_mva} onClose={this.handleDuplicaClose} />}
      </div >
    );
  }
}

export default MvasPaPage;
